import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../routes';
import Voln from '../svg/Voln';
import PortfolioItem from '../02_moleculas/PortfolioItem';

const Works = ({ portfolioLink, withTitle, wave, projects }) => (
  <div id="works">
    <div className="wrapper">
      {withTitle && (
        <div className="title_prom mb-4 font-weight-bold text-center text-uppercase">
            Портфолио
        </div>
      )}
      {wave && <Voln />}
      {Array.isArray(projects) && (
        <div className="works">
          {projects.map(project => <PortfolioItem {...project} key={project.uuid} />)}
        </div>
      )}
      {portfolioLink && (
        <div className="link_arrow">
          <Link to="/portfolio">
            <a>
              <p className="gpmed">ВСЕ РАБОТЫ</p>
            </a>
          </Link>
        </div>
      )}
    </div>
  </div>
);

Works.propTypes = {
  portfolioLink: PropTypes.bool,
  withTitle: PropTypes.bool,
  wave: PropTypes.bool,
  projects: PropTypes.arrayOf(PropTypes.shape({
    imageForGrid: PropTypes.string,
  })).isRequired,
};

Works.defaultProps = {
  portfolioLink: false,
  withTitle: false,
  wave: false,
};

export default Works;
